import React, { forwardRef } from 'react';
import styled from 'styled-components';

const LineGraphCaption = styled.div<{ fontSize: number; paddingLeft: number }>`
    text-align: left;
    font-family: sans-serif;
    color: #474747;
    font-size: ${({ fontSize }) => fontSize * 0.7}%;
    padding-left: ${({ paddingLeft }) => paddingLeft}px;
    display: block;
    white-space: pre-wrap;
`;

interface IProps {
    description: string;
    fontSize: number;
    paddingLeft: number;
}

const Description = forwardRef(({ description, fontSize, paddingLeft }: IProps, ref: React.Ref<HTMLDivElement>) => (
    <LineGraphCaption ref={ref} paddingLeft={paddingLeft} fontSize={fontSize}>
        {description}
    </LineGraphCaption>
));

export default Description;
